/**
 *  Arquivo responsável por gerenciar as actions para alterar o estado da aplicação
 * 
 */
import * as types from './mutations_types'

// seta as flags no state da aplicação
export const ActionSetFlags = ({ commit }, payload) => {
  commit(types.SET_FLAGS, payload);
}